<template>
  <b-container fluid>
    <b-row>
      <b-col
        v-show="
          isEmptyObj(user) || (!recentReqFilesLoading && !requests.length)
        "
        cols="12"
        class="py-5 text-center"
      >
        <h3 class="font-weight-bold">This lot is vacant</h3>
        <p class="text-secondary">You have no files yet.</p>
        <b-img fluid src="/img/empty-req.svg" alt="Empty File Requests"></b-img>
      </b-col>
      <b-col
        v-if="!isEmptyObj(user) || (!recentReqFilesLoading && requests.length)"
        cols="12"
      >
        <b-table
          responsive
          hover
          show-empty
          ref="recentReqFilesTable"
          :fields="fields"
          :items="requests"
          :busy="recentReqFilesLoading"
          @row-clicked="viewRequestDetails"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #head()="data">
            <span class="text-capitalize">{{ data.label }}</span>
          </template>

          <template #empty>
            <h6 class="text-center">Empty request file/s data</h6>
          </template>

          <template #emptyfiltered>
            <h6 class="text-center">No request file/s data found</h6>
          </template>

          <template
            #cell(name)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            {{
              data.item.file_share
                ? data.item.file_share.file.name
                : data.item.file_request.name
            }}
          </template>

          <template
            #cell(file_request.due_date)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            {{ data.item.file_request.due_date | formatDate }}
          </template>

          <template
            #cell(file_share.file.status)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            <template v-if="data.item.file_share">
              <b-badge
                pill
                :variant="statusBadge(data.item.file_share.file.status)"
                class="badge-hovered text-capitalize"
              >
                {{ data.item.file_share.file.status }}
              </b-badge>
            </template>
            <!-- <template
              v-else-if="data.item.has_shared"
              :class="'px-0 text-center recent-req-file-action-col'"
            >
              <b-badge
                pill
                variant="danger"
                class="badge-hovered text-capitalize"
              >
                Rejected
              </b-badge>
            </template> -->
            <template
              v-else
              :class="'px-0 text-center recent-req-file-action-col'"
            >
              <b-badge
                pill
                variant="secondary"
                class="badge-hovered text-capitalize"
              >
                Not Started
              </b-badge>
            </template>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-modal
      centered
      v-model="delModalShow"
      id="delete-file-modal"
      title="Delete selected file?"
    >
      <p class="my-4">
        Are you sure you want to delete the selected file?
      </p>

      <template #modal-footer>
        <b-button variant="secondary" @click="cancelDelFiles()">
          No
        </b-button>
        <b-button variant="primary" @click="deleteFiles(delModalId)">
          Yes
        </b-button>
      </template>
    </b-modal>

    <b-modal
      centered
      v-model="notStartedModalShow"
      id="not-started-file-modal"
      title="Choose existing file"
      @hide="notStartedHide"
    >
      <p class="my-4">
        Would you like to browse and choose from your existing files?
      </p>

      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="
            $router.replace({
              name: 'request.request-file-templates-page',
              params: {
                fileRequestUserId: selectedRequestId
              }
            })
          "
        >
          No, create new file
        </b-button>
        <b-button
          variant="primary"
          @click="
            $router.replace({
              name: 'request.files-page'
            })
          "
        >
          Yes, browse files
        </b-button>
      </template>
    </b-modal>

    <b-alert
      dismissible
      fade
      class="custom-alert"
      :show="dismissCountDown"
      :variant="alertType"
      @dismissed="clearAlert"
      @dismiss-count-down="dlCountDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { isEmpty } from 'lodash'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      recentReqFilesLoading: false,
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
      delModalShow: false,
      delModalId: 0,
      notStartedModalShow: false,
      selectedRequestId: null
    }
  },

  props: {
    tabIndex: {
      type: [Number, String],
      default: 0
    }
  },

  computed: {
    ...mapGetters('requests', ['requests']),
    ...mapGetters('auth', ['user']),

    userHeaderKey() {
      if (!isEmpty(this.user)) {
        if (this.tabIndex === 0) {
          return 'file_request.user.full_name'
        } else {
          return 'user.full_name'
        }
      } else {
        return ''
      }
    },

    userHeaderLabel() {
      if (!isEmpty(this.user)) {
        if (this.tabIndex === 0) {
          return 'Assigned By'
        } else {
          return 'Assigned To'
        }
      } else {
        return ''
      }
    },

    fields() {
      return [
        {
          key: 'name',
          label: 'File Name',
          class: 'w-25',
          sortable: true
        },
        {
          key: 'file_request.due_date',
          label: 'Due Date',
          class: 'w-25',
          sortable: true
        },
        // {
        //   key: 'file_request.project',
        //   label: 'Company Requesting',
        //   class: 'w-8',
        //   sortable: true
        // },
        {
          key: this.userHeaderKey,
          label: this.userHeaderLabel,
          class: 'w-25',
          sortable: true
        },
        {
          key: 'file_share.file.status',
          label: 'Status',
          class: 'w-25',
          sortable: true
        }
      ]
    }
  },

  filters: {
    formatDate(date) {
      return dayjs(date).format('DD MMM YYYY')
    }
  },

  methods: {
    ...mapActions('requests', {
      getRequestedTo: 'getRequestedTo',
      getRequestedBy: 'getRequestedBy'
    }),
    ...mapMutations('requests', {
      setFileRequest: 'setFileRequest',
      clearFileRequest: 'clearFileRequest'
    }),

    async getRecentRequestedFiles(filter = null) {
      this.recentReqFilesLoading = true

      if (!isEmpty(this.user)) {
        if (this.tabIndex === 0 || this.user.user_type === 'tradie') {
          await this.getRequestedTo(filter).finally(() => {
            this.recentReqFilesLoading = false
          })
        }

        if (this.tabIndex === 1) {
          await this.getRequestedBy(filter).finally(() => {
            this.recentReqFilesLoading = false
          })
        }
      }
    },

    viewRequestDetails(item, i) {
      if (this.tabIndex === 0) {
        if (
          !(
            item.file_share &&
            (item.file_share.file.status !== 'valid' ||
              item.file_share.file.status !== 'rejected' ||
              item.file_share.file.status !== 'pending approval')
          )
        ) {
          this.setFileRequest(item.file_request_id)
          this.notStartedShow(item.id)
        } else {
          this.$router.push({
            name: 'request.view-requested-by-page',
            params: {
              id: item.id
            }
          })
        }
      }

      if (this.tabIndex === 1) {
        this.$router.push({
          name: 'request.view-requested-to-page',
          params: {
            id: item.file_request_id
          }
        })
      }
    },

    async deleteFiles(id) {
      await this.$api
        .delete(`file/${id}`)
        .then(async ({ data }) => {
          if (data.success) {
            this.alertMsg = 'Delete file successful!'
            this.dismissCountDown = 5
            await this.getRecentRequestedFiles()
            this.cancelDelFiles()
          }
        })
        .catch(e => {
          setTimeout(e => {
            this.clearAlert()
          }, 5000)

          this.alertType = 'danger'
          this.alertMsg = 'Something went wrong while deleting file!'
          this.dismissCountDown = 5
          this.cancelDelFiles()
        })
    },

    showDelFiles(id) {
      this.delModalShow = true
      this.delModalId = id
    },

    cancelDelFiles() {
      this.delModalShow = false
      this.delModalId = 0
    },

    dlCountDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    },

    isEmptyObj(obj) {
      return isEmpty(obj)
    },

    notStartedShow(selectedRequestId) {
      this.notStartedModalShow = true
      this.selectedRequestId = selectedRequestId
    },

    notStartedHide() {
      this.notStartedModalShow = false
      this.selectedRequestId = null
      this.clearFileRequest()
    },

    statusBadge(status) {
      return status === 'valid'
        ? 'success'
        : status === 'pending approval'
        ? 'warning'
        : status === 'rejected'
        ? 'danger'
        : 'secondary'
    }
  },

  watch: {
    async user() {
      await this.getRecentRequestedFiles()
    },

    async tabIndex() {
      await this.getRecentRequestedFiles()
    },

    recentReqFilesLoading(newVal, oldVal) {
      this.$emit('loading', newVal)
    }
  },

  async mounted() {
    // await this.getRecentRequestedFiles()

    if (!isEmpty(this.user)) {
      await this.getRecentRequestedFiles()
    }

    this.$root.$on('submitRequestsFilters', async filters => {
      await this.getRecentRequestedFiles(filters)
    })
  }
}
</script>

<style lang="scss" scoped>
/deep/ .b-table {
  & > tbody {
    & > tr:not(:hover) {
      & .show-when-hovered {
        display: none;
      }
    }

    & > tr:hover {
      & .show-when-hovered {
        display: flex;
      }
    }
  }
}

/deep/ .recent-req-file-action-col {
  width: 3vw !important;
}

@media (pointer: fine) {
  /deep/ .b-table {
    & > tbody {
      & > tr:not(:hover) {
        & .show-when-hovered {
          display: none;
          // visibility: hidden;
        }
      }

      & > tr:hover {
        & .show-when-hovered {
          display: inherit;
          // visibility: visible;
        }
      }
    }
  }
}
</style>
